<template>
  <div>
    <v-toolbar flat color="white">
      <v-toolbar-title>Reporte de documentos firmados</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    
    <v-card>
      <v-layout row wrap>
        <v-flex px-2 xs12 sm3>
          <v-select
            :items="sign_dates"
            v-model="filter_sign"
            label="Filtrar Fecha de firma"
            item-text="description"
            item-value="id"
            clearable
            @change="setFilter()"
          ></v-select>
        </v-flex>
        <v-flex px-2 xs12 sm3>
          <v-select
            v-model="filter_document"
            :items="documents"
            label="Filtrar Documento"
            item-text="name"
            item-value="id"
            clearable
            @change="setFilter(); filter_state = null"
            @click:clear="filter_document = null; setFilter()"
          ></v-select>
        </v-flex>
        <v-flex px-2 xs12 sm3>
          <v-select
            v-if="filter_document"
            :items="[
              { value: 'P', name: 'Pendiente' },
              { value: 'F', name: 'Firmado' },
              { value: 'R', name: 'Rechazado' },
              { value: '', name: 'Sin firmar' },
              { value: 'null', name: 'Sin asignar' },
            ]"
            v-model="filter_state"
            label="Filtrar Estado"
            item-text="name"
            item-value="value"
            multiple
            @change="setFilter()"
            @click:clear="filter_state = null; setFilter()"
          ></v-select>
        </v-flex>
        <v-flex px-2 xs12 sm3>
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Buscar"
            single-line
            hide-details
          ></v-text-field>
        </v-flex>
      </v-layout>
      <v-data-table
          class="the-table"
          :headers="tableHeaders"
          :items="tableData"
          :search="search"
          :loading="loadingTable"
          :custom-sort="customSort"
          :rows-per-page-text="$t('datatable.rowsPerPageText')"
          :no-results-text="$t('datatable.noResultsText')"
          :no-data-text="$t('datatable.noDataText')"
          :rows-per-page-items="[10,20,50,{'text':$t('datatable.allRowsPerPageItems'),'value':-1}]"
      >
       <template slot="items" slot-scope="props">
          <td
            v-for="(head, i) in tableHeaders"
            :key="`t-${i}`"
            :class="[head.document || !head.value.includes('employee','centro_costos') ? 'text-xs-center wrap' : '', head.value.includes('employee','centro_costos') ? 'nowrap' : '']"
          >
            {{ !head.document ? props.item[head.value] : '' }}
            <v-icon
                v-if="head.document && props.item[`${head.value}`] && props.item[`${head.value}`].split(',')[0] == ''"
                medium
                title="Sin firmar"
                color="grey"
              >
              remove_circle
            </v-icon>
            <v-icon
              v-else-if="head.document && props.item[`${head.value}`] && props.item[`${head.value}`].split(',')[0] == 'F'"
              medium
              title="Firmado"
              color="success"
              @click="loadDocument(props.item[`${head.value}`].split(',')[1])"
            >
              check_circle
            </v-icon>
            <v-icon
              v-else-if="head.document && props.item[`${head.value}`] && props.item[`${head.value}`].split(',')[0] == 'P'"
              medium
              title="Pendiente"
              color="warning"
            >
              info
            </v-icon>
            <v-icon
              v-else-if="head.document"
              medium
              :title="`N/A -${props.item[`${head.value}`]}-`"
              color="error"
              >
              highlight_off
            </v-icon>
          </td>
        </template>
        <template v-slot:pageText="props">
          {{ props.pageStart }} - {{ props.pageStop }} de {{ props.itemsLength }}
        </template>
      </v-data-table>
    </v-card>
    <v-dialog
      v-model="dialogDigitalSign"
      fullscreen>
      <digital-sign-comp
        v-on:closeDialog="closeSignDialog"
        :studentId="''"
        :documentId="0"
        :action="action"
        :processId="0"
        :recordId="vista_record_id"
      ></digital-sign-comp>
    </v-dialog>
  </div>
</template>

<script>
  import axios from 'axios'
  import DigitalSignComponent from './digital_sign'
  export default {
    name: 'employee-sign-report',
    components: {
      'digital-sign-comp': DigitalSignComponent,
    },
    data() {
      return {
        sign_dates: [],
        filter_sign: '',
        filter_document: '',
        filter_state: null,
        signDateEmployees: [],
        employees: [],
        documents: [],
        tableHeaders: [],
        tableData: [],
        originalData: [],
        search: '',
        dialogDigitalSign: false,
        vista_record_id: 0,
        action: '',
        loadingTable: false
      }
    },
    computed: {
    },
    created () {
      this.init();
    },
    methods: {
      init() {
        this.loadingTable = true
        axios.get(`/api/documents/sign_date/employees/report`)
          .then(resp => {
            if (resp.status === 200) {
              this.loadingTable = false
              this.signDateEmployees = resp.data.sign_date_employees
              this.employees = resp.data.siesa_employees
              this.documents = resp.data.documents
              this.setData()
              this.setFilter()
            }
          })
          .catch(err => console.log(err))
        axios.get('/api/documents/sign_dates')
        .then(resp => {
          if (resp.status === 200) {
            this.loadingTable = false
            this.sign_dates = resp.data.filter(data => data.type == 'EMP');
          }
        })
      },
      setData() {
        this.loadingTable = false
        let headers = []

        headers.push(
          { text: 'Empleado', align: 'start', value: 'employee', document: false, width: '280px' },
          { text: 'Id CC', align: 'center', value: 'id_centro_costos', document: false },
          { text: 'CC', align: 'center', value: 'centro_costos', document: false, width: '200px' },
          { text: 'G. Empl.', align: 'center', value: 'grupo_empleados', document: false },
        )

        this.documents.forEach(document => {
          headers.push(
            {
              text: document.name,
              align: 'center',
              value: "doc_"+document.id,
              document: true,
              width: "180px",
              orderable: true,
              class: 'wrap',
            }
          )
        })

        let data = []
        
        this.employees.forEach(emp => {
          let dataObj = {
            employee: emp.full_name,
            id_centro_costos: emp.id_centro_costos,
            centro_costos: emp.centro_costos,
            grupo_empleados: emp.grupo_empleados,
          }
          this.documents.forEach(doc => {
            // const signedDocument = this.findAssignedDocument(emp.rowid_tercero, doc.id)
            let signObj = this.signDateEmployees.reduce(function(ids, obj){
              if(obj.siesa_rowid_id == emp.rowid_tercero && obj.school_document_id == doc.id){
                  ids.push({
                    [`doc_${doc.id}`]: obj[`360_document_status`] == null || obj[`360_document_id`] == null ? null : `${obj[`360_document_status`]},${obj[`360_document_id`]}`,
                    [`state_doc_${doc.id}`]: obj[`360_document_status`] == null ? null : obj[`360_document_status`],
                    [`date_sign_${obj.documents_sign_date_id}`]: true,

                    // [`${doc.name}`]: `doc_${doc.id}`
                  });
              } 
              return ids;
            }, [{[`doc_${doc.id}`]: ",", [`state_doc_${doc.id}`]: "" }]);
            
            signObj.forEach(element =>
              dataObj = {...dataObj, ...element }
            )      
          })
          data.push(dataObj)
        })
        this.originalData = data
        this.loadingTable = false
        this.tableHeaders = headers
      },
      findAssignedDocument(rowid, document_id) {
        return this.signDateEmployees
          .filter(sign => {
            if (this.filter_sign && this.filter_sign !== '') {
              return sign.documents_sign_date_id == this.filter_sign
            }
            return true
          })
          .find(sign =>
            sign.siesa_rowid_id == rowid && sign.school_document_id == document_id
          )
      },
      setFilter() {
        this.loadingTable = true
        let data = this.originalData
        let filter_state_array = []
        if (this.filter_document && this.filter_document !== ""){
          // data = data.filter( x => x[`doc_${this.filter_document}`])
          if (this.filter_state && Object.keys(this.filter_state).length > 0){
            this.filter_state.forEach(
              state => filter_state_array.push((state === 'null' ? null : state))
            )
            data = data.filter( x => filter_state_array.includes(x[`state_doc_${this.filter_document}`]) )
          }       
        }
        if (this.filter_sign && this.filter_sign !== ""){
          data = data.filter( x => x[`date_sign_${this.filter_sign}`])
        }
        this.tableData = data
        this.loadingTable = false
      },
      customSort(items, index, isDescending) {
        items.sort((a, b) => {
          if (a[`${index}`] == null) a[`${index}`] = ''
          if (b[`${index}`] == null) b[`${index}`] = ''
          if (isDescending) {
              return b[`${index}`].localeCompare(a[`${index}`]);
          } else {
              return a[`${index}`].localeCompare(b[`${index}`]);
          }
        });
        return items;
      },
      loadDocument(doc_id) {
        this.dialogDigitalSign = true
        this.action = 'SHOW'
        this.vista_record_id = doc_id
      },
      closeSignDialog() {
        this.action = ''
        this.dialogDigitalSign = false
      }
    },
  }
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/documents/employee_sign_report.vue